import React from 'react';
import PropTypes from 'prop-types';
import { Grid } from '@esgian/esgianui';

import FuturePortCallsTable from '@components/Tables/FuturePortCallsTable';

function FutureScheduleSection({ operatorShortName = '', futurePortCallsQuery }) {
  return (
    <>
      <Grid item xs={12}>
        <FuturePortCallsTable
          loading={futurePortCallsQuery.isFetching}
          assetLevel={'operator'}
          futurePortCalls={futurePortCallsQuery.data}
          name={operatorShortName}
        />
      </Grid>
    </>
  );
}

FutureScheduleSection.propTypes = {
  operatorShortName: PropTypes.string,
  futurePortCallsQuery: PropTypes.object
};

export default FutureScheduleSection;
